import {
  checkHttpStatus,
  getApiHeaders,
  getApiBaseUrlWithOrg
} from '../utils/api'
import { push } from 'connected-react-router'

export const FETCH_CLASS_ROOMS_REQUEST = 'FETCH_CLASS_ROOMS_REQUEST'
export const FETCH_CLASS_ROOMS_SUCCESS = 'FETCH_CLASS_ROOMS_SUCCESS'

export const fetchClassRoomsRequest = () => ({
  type: FETCH_CLASS_ROOMS_REQUEST
})

export const fetchClassRoomsSuccess = classRooms => ({
  type: FETCH_CLASS_ROOMS_SUCCESS,
  payload: {
    classRooms
  }
})

export function fetchClassRooms() {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(state.organization.orgId)}/class_rooms`

    dispatch(fetchClassRoomsRequest())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )
      const data = await response.json()

      dispatch(fetchClassRoomsSuccess(data))
    } catch (error) {
      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }

      if (error.response.status === 500) {
        dispatch(push('/error'))
      }
    }
  }
}
